/**
 * 파일 업로드 모드별 계약. 편집기(`editor-upload-view`)와 대사(`initial-upload-view`)가
 * 같은 세그먼트를 쓰므로 "공시본 카드는 zip 만 받는다"가 두 곳에서 따로 바뀌면 안 된다.
 *
 * `description` 은 일부러 뺐다 — 같은 zip 이라도 편집기는 "열람만 가능",
 * 대사는 "대사 결과를 편집할 수 없음"이라 화면마다 뜻이 다르다. 각 화면이 넘긴다.
 */
export const UPLOAD_CARD_BY_MODE = {
  upload: {
    label: "IXD 파일",
    accept: ".ixd",
    /** 편집용 변환 안내는 .ixd 를 받는 모드에서만 뜻이 있다. */
    showConversionGuide: true,
  },
  "dart-filing": {
    label: "XBRL 공시본",
    accept: ".zip",
    showConversionGuide: false,
  },
} as const;

/** 파일을 직접 올리는 모드. `existing-report` 는 카드가 아니라 피커라 여기 없다. */
export type FileUploadMode = keyof typeof UPLOAD_CARD_BY_MODE;
